function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Group_1865",
  "data-name": "Group 1865"
}, /*#__PURE__*/React.createElement("circle", {
  id: "Ellipse_9",
  "data-name": "Ellipse 9",
  cx: 16,
  cy: 16,
  r: 16,
  fill: "#eeeff3"
}));

var _ref3 = /*#__PURE__*/React.createElement("path", {
  id: "hourglass_top_FILL1_wght400_GRAD0_opsz48",
  d: "M10.827,17.412h5.945v-2.3a3.077,3.077,0,0,0-.861-2.184,2.893,2.893,0,0,0-4.223,0,3.077,3.077,0,0,0-.861,2.184ZM19.056,18.5H8.544a.544.544,0,1,1,0-1.087h1.2v-2.3a4.314,4.314,0,0,1,.662-2.329,3.756,3.756,0,0,1,1.84-1.531A3.742,3.742,0,0,1,10.4,9.709,4.359,4.359,0,0,1,9.74,7.371V5.087h-1.2A.544.544,0,1,1,8.544,4H19.056a.544.544,0,1,1,0,1.087h-1.2V7.371a4.316,4.316,0,0,1-.671,2.338,3.8,3.8,0,0,1-1.831,1.541,3.756,3.756,0,0,1,1.84,1.531,4.314,4.314,0,0,1,.662,2.329v2.3h1.2a.544.544,0,1,1,0,1.087Z",
  transform: "translate(2.098 4.75)",
  fill: "#7ec884"
});

var SvgHourglass = function SvgHourglass(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_2734",
    "data-name": "Group 2734",
    width: 42,
    height: 42,
    viewBox: "0 0 32 32",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgHourglass, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/hourglass.33e74165.svg";
export { ForwardRef as ReactComponent };